import TextField from './text';
import TextAreaField from './area';
import CheckboxField from './checkbox';
import DurationField from './duration';
import SelectField from './select';
import RadioField from './radio';
import DateField from './date';
import BirthdayField from './birthday';
import TimeField from './time';
import AttachedCalendar from './attachedCalendar';
import BigRadioOption from './bigRadioOption';
import PhoneField from './phone';

export {
    TextField,
    TextAreaField,
    CheckboxField,
    DurationField,
    SelectField,
    RadioField,
    DateField,
    BirthdayField,
    TimeField,
    AttachedCalendar,
    BigRadioOption,
    PhoneField
};



// WEBPACK FOOTER //
// ./src/components/fields/index.js